module.exports = __webpack_public_path__ + "static/media/icon-change-green.d718ceab.svg";